import { List, Map } from 'immutable';

import { TYPES } from './actions';
import { SESSION_DESTROY } from '../../actions';
import Logger from '../../../lib/Logger';

const initialState = Map({
  isLoading: false,
  pages: {},
  total: 0,
  results: {},
  isFileDownloading: false,
  form: {},
  isFormVisible: false,
  isPreviewVisible: false,
  id: null,
  isSubmitting: false,
  isDocumentUploading: false,
  isRemoveFile: false,
  isCSVDownloading: false,
  isCareGuideDocumentUploadUrlLoading: false,
});

export default function careGuideDocuments(state = initialState, action) {
  Logger.log(
    'debug',
    `[state.careGuideDocuments.reducers] careGuideDocuments(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case TYPES.LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.careGuideId]: {
              [action.order]: {
                [action.limit]: {
                  [action.page]: null,
                },
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            'pages',
            action.careGuideId,
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.DOWNLOAD_URL_REQUEST:
      return state.mergeDeep({
        isFileDownloading: true,
      });

    case TYPES.DOWNLOAD_URL_SUCCESS:
    case TYPES.DOWNLOAD_URL_FAILURE:
      return state.mergeDeep({
        isFileDownloading: false,
      });

    case TYPES.PATCH_REQUEST:
    case TYPES.CREATE_REQUEST:
    case TYPES.UPDATE_REQUEST:
      return state.mergeDeep({
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.PATCH_SUCCESS:
    case TYPES.UPDATE_SUCCESS:
    case TYPES.CREATE_SUCCESS:
      return state.mergeDeep({
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.PATCH_FAILURE:
    case TYPES.UPDATE_FAILURE:
    case TYPES.CREATE_FAILURE:
      return state
        .mergeDeep({
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.FORM_DESTROY:
      return state
        .mergeDeep({
          form: {},
          id: null,
        })
        .set('form', action.form);

    case TYPES.SHOW_FORM:
      return state.mergeDeep({
        isFormVisible: true,
        id: action.id,
      });

    case TYPES.HIDE_FORM:
      return state.mergeDeep({
        isFormVisible: false,
      });

    case TYPES.PREVIEW_DESTROY:
      return state.mergeDeep({
        isPreviewVisible: false,
        id: null,
      });

    case TYPES.SHOW_PREVIEW:
      return state.mergeDeep({
        isPreviewVisible: true,
        id: action.id,
      });

    case TYPES.HIDE_PREVIEW:
      return state.mergeDeep({
        isPreviewVisible: false,
      });

    case TYPES.UPLOAD_REQUEST:
      return state.mergeDeep({
        isDocumentUploading: true,
      });

    case TYPES.UPLOAD_FAILURE:
    case TYPES.UPLOAD_SUCCESS:
      return state.mergeDeep({
        isDocumentUploading: false,
      });

    case TYPES.REMOVE_FILE_REQUEST:
      return state.mergeDeep({
        isRemoveFile: true,
      });

    case TYPES.REMOVE_FILE_FAILURE:
    case TYPES.REMOVE_FILE_SUCCESS:
      return state.mergeDeep({
        isRemoveFile: false,
      });

    case TYPES.CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true,
      });

    case TYPES.CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case TYPES.CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case TYPES.UPLOAD_URL_REQUEST:
      return state.mergeDeep({
        isCareGuideDocumentUploadUrlLoading: true,
        upload: {},
      });

    case TYPES.UPLOAD_URL_SUCCESS:
      return state.mergeDeep({
        isCareGuideDocumentUploadUrlLoading: false,
        upload: {
          upload_url: action.upload_url,
          file_key: action.file_key,
        },
      });

    case TYPES.UPLOAD_URL_FAILURE:
      return state.mergeDeep({
        isCareGuideDocumentUploadUrlLoading: false,
        upload: {},
      });

    case SESSION_DESTROY:
      return initialState;

    default:
      return state;
  }
}

Logger.log('silly', `state.careGuideDocuments.reducers loaded.`);
